import React from "react";

const WORDS = [
  "Connecting India", "Delivering World", "Raw Materials", "Agricultural Exports",
  "Custom Container Freight", "Air • Sea • Road", "On-Demand Trade",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-[#111C2E] py-6" data-testid="editorial-marquee">
      <div className="animate-marquee">
        {row.map((w, i) => (
          <span key={i} className="mx-6 inline-flex items-center gap-6 font-display text-2xl font-bold uppercase tracking-tight text-white/90 sm:text-3xl">
            {w}
            <span className="h-2 w-2 rounded-full bg-[#E65100]" />
          </span>
        ))}
      </div>
    </div>
  );
}
